<template>
  <footer class="site-footer">
    <div class="footer-container">
      <div class="footer-brand">
        <div class="brand-logo">
          <h1 class="brand-name">TitlJam AI</h1>
        </div>
        <p class="brand-desc">
          2026年领先的AI内容营销助手，助力每一位创作者提升影响力。
        </p>
        <div class="social-links">
          <a href="javascript:;" class="social-icon" @click="openModal">
            <img src="../assets/xhs.png" alt="小红书" class="xhs-img" />
          </a>
          <a href="javascript:;" class="social-icon" @click="openModal">
            <img src="../assets/xhs.png" alt="小红书" class="xhs-img" />
          </a>
          <a href="javascript:;" class="social-icon" @click="openModal">
            <img src="../assets/xhs.png" alt="小红书" class="xhs-img" />
          </a>
        </div>
      </div>

      <div class="footer-column">
        <h3 class="column-title">产品</h3>
        <ul class="column-links">
          <li><a href="#">标题生成</a></li>
          <li><a href="#">热门词库</a></li>
          <li><a href="#">SEO优化</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h3 class="column-title">资源</h3>
        <ul class="column-links">
          <li><a href="#">创作博客</a></li>
          <li><a href="#">教程中心</a></li>
          <li><a href="#">成功案例</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h3 class="column-title">公司</h3>
        <ul class="column-links">
          <li><a href="#">关于我们</a></li>
          <li><a href="#">品牌合作</a></li>
          <li><a href="#">加入我们</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h3 class="column-title">支持</h3>
        <ul class="column-links">
          <li><a href="#">在线客服</a></li>
          <li><a href="#">隐私协议</a></li>
          <li><a href="#">常见问题</a></li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      <p class="copyright">© 2026 TitlJam 内容营销实验室 版权所有</p>
      <a href="#" class="terms-link">服务条款</a>
    </div>

    <Modal v-model="showModal"
           title="关注我们"
           imgUrl="idcard.jpg"
           content="小红书：TitlJam AI 官方账号"
    />
  </footer>
</template>

<script>
import Modal from './Modal.vue';

export default {
  name: "Footer",
  components: { Modal },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    openModal() {
      this.showModal = true;
    }
  }
};
</script>

<style scoped>
.site-footer {
  width: 100%;
  background: #f8fafc;
  padding: 30px 20px 20px; /* 整体高度压小 */
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: #334155;
  border-top: 1px solid #e2e8f0;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  gap: 24px; /* 间距缩小 */
  margin-bottom: 24px;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.brand-logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-name {
  font-size: 26px; /* 缩小一点 */
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.brand-desc {
  font-size: 14px;
  line-height: 1.4;
  color: #64748b;
  max-width: 400px;
  margin: 0;
}

.social-links {
  display: flex;
  gap: 12px;
}

.social-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  transition: all 0.3s ease;
  cursor: pointer;
}

.social-icon:hover {
  background: #ff2442;
  border-color: #ff2442;
}

.xhs-img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}

.footer-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.column-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.column-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.column-links li a {
  font-size: 13px;
  color: #64748b;
  text-decoration: none;
}

.column-links li a:hover {
  color: #4f46e5;
}

.footer-bottom {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.copyright {
  font-size: 12px;
  color: #64748b;
  margin: 0;
}

.terms-link {
  font-size: 12px;
  color: #64748b;
  text-decoration: none;
}

/* ===================== 移动端适配（紧凑版） ===================== */
@media (max-width: 992px) {
  .footer-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  .footer-brand {
    grid-column: 1 / -1;
    align-items: center;
    text-align: center;
  }
  .brand-desc {
    max-width: 100%;
  }
}

@media (max-width: 576px) {
  .site-footer {
    padding: 24px 16px 16px; /* 手机更紧凑 */
  }
  .footer-container {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }
  .social-links {
    justify-content: center;
  }
  .footer-bottom {
    flex-direction: column;
    gap: 4px;
    padding-top: 12px;
  }
}
</style>